"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GameCard = function (_a) {
    var gameId = _a.gameId, gameCardPlaceholder = _a.gameCardPlaceholder, withPlay = _a.withPlay, withBigPreview = _a.withBigPreview;
    var _b = (0, swr_hooks_1.useFreespinsGames)({ id: gameId }), data = _b.data, isLoading = _b.isLoading;
    var lang = (0, next_intl_1.useLocale)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var config = (0, swr_hooks_1.useConfig)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var gameInfoLink = (0, apps_shared_1.useModalLink)("".concat(apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL).concat(gameId));
    var router = (0, navigation_1.useRouter)();
    var openInfoModal = (0, react_1.useCallback)(function () {
        var gameLink = generateUrlWithLang("/game/".concat(gameId));
        if (config === null || config === void 0 ? void 0 : config.gameCardMobileOpenGameInstant)
            return router.push(gameLink);
        router.push(gameInfoLink);
    }, [
        router,
        gameInfoLink,
        config === null || config === void 0 ? void 0 : config.gameCardMobileOpenGameInstant,
        gameId,
        generateUrlWithLang,
    ]);
    if (isLoading || !data)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.gameWrapper), onClick: openInfoModal },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.gameCover, " gameCover") },
                    react_1.default.createElement(ui_components_1.Image, { src: (0, apps_shared_1.getGameImageURL)(data === null || data === void 0 ? void 0 : data.id), alt: data === null || data === void 0 ? void 0 : data.title, placeholder: gameCardPlaceholder, rootMargin: "0px" }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.name }, data === null || data === void 0 ? void 0 :
                data.title,
                withPlay && (react_1.default.createElement(ui_components_1.FixedButton, { onClick: openInfoModal, width: "min-content", maxWidth: "min-content", height: "28px", className: styles_module_scss_1.default.activateButton, text: "upper", color: "gradient" }, t('play')))))),
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/game/").concat(gameId) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.gameWrapper, " ").concat(withBigPreview ? styles_module_scss_1.default.bigPreview : '') },
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.backgroundMask, " backgroundMask") }),
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.gameCover, " gameCover") },
                        react_1.default.createElement(ui_components_1.Image, { src: (0, apps_shared_1.getGameImageURL)(data === null || data === void 0 ? void 0 : data.id), alt: data === null || data === void 0 ? void 0 : data.title, placeholder: gameCardPlaceholder, rootMargin: "0px" }))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.name }, data === null || data === void 0 ? void 0 :
                    data.title,
                    withPlay && (react_1.default.createElement(ui_components_1.FixedButton, { width: "min-content", maxWidth: "min-content", height: "28px", className: styles_module_scss_1.default.activateButton, text: "upper", color: "gradient" }, t('play')))))))));
};
exports.default = GameCard;
